import { Link, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Text, TopbarActions, TopbarLeading, buttonVariants } from "@/shared/ui";
import { cn } from "@/shared/lib/cn";
import { ApiNotice } from "./ApiNotice";

const sections = [
  { to: "/ugc", labelKey: "ugc.navigation.campaigns", exact: true },
  { to: "/ugc/identities", labelKey: "ugc.navigation.identities", exact: false },
  { to: "/ugc/brand-kits", labelKey: "ugc.navigation.brandKits", exact: false },
  { to: "/ugc/product-kits", labelKey: "ugc.navigation.productKits", exact: false },
] as const;

export function UgcLayout() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto w-full max-w-[1180px] px-6 pb-12 pt-3 max-[880px]:px-4 max-[880px]:[&_a]:min-h-11 max-[880px]:[&_button]:min-h-11 max-[880px]:[&_input]:min-h-11 max-[880px]:[&_select]:min-h-11">
      <TopbarLeading>
        <Text variant="h4" as="span" className="max-[880px]:hidden">
          {t("ugc.title")}
        </Text>
      </TopbarLeading>
      <TopbarActions>
        <Link
          to="/ugc/campaigns/new"
          search={{ step: 1 }}
          className={cn(buttonVariants({ variant: "accent", size: "sm" }), "max-[880px]:hidden")}
        >
          <span aria-hidden="true">＋</span>
          {t("ugc.actions.newCampaign")}
        </Link>
      </TopbarActions>

      <header className="hidden items-center justify-between gap-3 pb-4 max-[880px]:flex">
        <Text variant="h4" as="span">
          {t("ugc.title")}
        </Text>
        <Link to="/ugc/campaigns/new" search={{ step: 1 }} className={buttonVariants({ variant: "accent", size: "sm" })}>
          <span aria-hidden="true">＋</span>
          {t("ugc.actions.newCampaign")}
        </Link>
      </header>

      <ApiNotice />

      <nav
        aria-label={t("ugc.navigation.label")}
        className="mt-4 flex gap-1 overflow-x-auto border-b border-line pb-px"
      >
        {sections.map((section) => (
          <Link
            key={section.to}
            to={section.to}
            activeOptions={{ exact: section.exact }}
            className="group relative shrink-0 rounded-sm px-3 py-2.5 font-sans text-[13.5px] font-medium text-ink-soft outline-none transition-colors duration-150 ease-house hover:text-ink focus-visible:ring-2 focus-visible:ring-tint data-[status=active]:text-ink"
          >
            {t(section.labelKey)}
            <span
              aria-hidden="true"
              className="absolute inset-x-3 bottom-[-2px] hidden h-[2px] rounded-full bg-accent group-data-[status=active]:block"
            />
          </Link>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
